import { useRef } from "react";

export function PhoneFrame({ screen, testId, onOpen, size = "regular", className = "" }) {
  const shellRef = useRef(null);

  const move = (event) => {
    if (!shellRef.current || !window.matchMedia("(hover: hover)").matches) return;
    const rect = shellRef.current.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    shellRef.current.style.setProperty("--rx", `${y * -7}deg`);
    shellRef.current.style.setProperty("--ry", `${x * 7}deg`);
  };

  const reset = () => {
    shellRef.current?.style.setProperty("--rx", "0deg");
    shellRef.current?.style.setProperty("--ry", "0deg");
  };

  return (
    <button
      type="button"
      className={`phone-button ${className}`}
      data-testid={testId}
      aria-label={`Open ${screen.name} screenshot`}
      onClick={onOpen}
      onPointerMove={move}
      onPointerLeave={reset}
    >
      <span className={`phone-float phone-float-${size}`}>
        <span ref={shellRef} className="phone-shell">
          <span className="phone-bezel">
            <span className="phone-screen">
              <img
                src={screen.src}
                alt={`${screen.name} real Orlis AI app screenshot`}
                data-testid={`${testId}-screen`}
                loading={size === "hero" ? "eager" : "lazy"}
                decoding="async"
              />
            </span>
          </span>
        </span>
      </span>
    </button>
  );
}
